import { ONLY_DIGITS, VALID_LENGTHS } from '../validation'

const VALUES_SEPARATOR = /,|\n| |\r\n/g

export const processValues = (data: string) =>
  Array.from(
    new Set(data.split(VALUES_SEPARATOR).filter((bin) => bin.trim().length))
  )

/**
 * Filter by only digits && valid sizes (6 or 8)
 * @param entries Processed entries Array
 * @returns Valid entries Array
 */
export const filterValidEntries = (entries: string[]) =>
  entries.filter(
    (bin) => ONLY_DIGITS.test(bin) && VALID_LENGTHS.includes(bin.length)
  )

export const filterRepeatedEntries = (
  entries: string[],
  prevEntries: string[]
) => entries.filter((e) => !prevEntries.includes(e))
